import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const getDeviceRegistrationData = async (company, author) => {
    try {

        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.MOBILE}/v1/mobileDevice/get-register-data-QR/${company}/${author}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
export const getRegisteredDevices = async (company, author) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.MOBILE}/v1/mobileDevice/registeredDevices/${company}/${author}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
export const processDeviceActive = async (selectedDeviceIds, active) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.MOBILE}/v1/mobileDevice/update-deviceActive/${selectedDeviceIds}/${active}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getUserProfileData = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.MOBILE}/v1/user/profile/user-info`,
            data
        );
        return response;
    } catch (e) {
        console.error(e);
    }
};

export const sendRegisterDeviceDataByForm = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.MOBILE}/v1/mobileDevice/send-register-data-form`,
            data
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getUserByStkData = async (stkId) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.MOBILE}/v1/mobileDevice/user-stakeholder-details/${stkId}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const sendRegisterBulkData = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.MOBILE}/v1/mobileDevice/send-register-bulk-data`,
            data
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
